import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BooksProvider } from "@/context/BooksContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import OrganizationSchema from "@/components/OrganizationSchema";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import BookDetail from "@/pages/BookDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import ResetPassword from "@/pages/ResetPassword";

function PublicLayout() {
  return (
    <>
      <OrganizationSchema />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#FFFBF2]">
      <BrowserRouter>
        <BooksProvider>
          <ScrollToTop />
          <GoogleAnalytics />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/books/:slug" element={<BookDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BooksProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
